import { License } from "../_models/License";

export class LicenseMapper {
    static allServerToLocal(serverLicenses = []) {
        return serverLicenses.map(this.serverToLocal);
    }

    static serverToLocal(serverLicense) {
        return License({
            id: serverLicense.id,
            uid: serverLicense.uid,
            status: serverLicense.status,
            createdOn: serverLicense.created_on,
            validUntil: serverLicense.valid_until,
            cancelledOn: serverLicense.cancelled_on,
            renewalNoticeSentOn: serverLicense.renewal_notice_sent_on,
            quantity: serverLicense.quantity,
            licenseTypeUID: serverLicense.license_type_uid,
            locationUID: serverLicense.location_uid,
            locationName: serverLicense.location_name,
            locationOwnerEmail: serverLicense.location_owner_email,
            renewalCount: serverLicense.renewal_count,
            renewalPeriodStarts: serverLicense.renewal_period_starts,
            licenseTypeName: serverLicense.license_type_name,
            own: serverLicense.own,
        });
    }
}
